import Loginimg from "../../assets/images/Loginimg.png";
import Loginlogo from "../../assets/images/loginlogo.png";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { useState } from "react";

import useAuthStore from "../../store/authStore";
import ForgotPass from "./ForgotPassword/ForgotPass";
import { login } from "../../api/AuthRequest";
import { getDeviceInfo, requestFCMToken } from "../firebase/firebaseConfig";
import { saveFCMToken } from "../../api/NotificationRequest";
import useStateStore from "../../store/stateStore";


const Login = () => {
  const [loginView, setLoginView] = useState(true);

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { loginCall, updateFcmToken } = useAuthStore();
  const { fetchNotifications } = useStateStore();


  const handleLogin = async (loginData) => {
    try {
      setLoader(true);

      const { data } = await login(loginData);

      if (data?.success) {
        loginCall(data);
        await fetchNotifications(null, null, data?.user._id)
        setLoader(false);
        navigate("/");
        const token = await requestFCMToken()
        // console.log("FCM token", token);
        const deviceInfo = await getDeviceInfo()
        // console.log(deviceInfo, 'deviceInfo');

        const fcmToken = {
          token: token,
          deviceInfo: deviceInfo
        }
        const response = await saveFCMToken(fcmToken)
        updateFcmToken(response?.data?.data?.token)

      } else {
        setError(data?.message || "An error occurred during login.");
        setLoader(false);
      }
    } catch (error) {
      setError(
        error.response?.data?.message || "An error occurred during login."
      );
      setLoader(false);
    }
  };
  // ------- buttons to render ------

  return (
    <>
      {loginView ? (
        <>
          <div className="lg:hidden md:hidden flex justify-center  p-3">
            <img
              src={Loginlogo}
              className="h-32 "
              alt="Architectural background"
            />
          </div>
          <div className="lg:flex md:flex lg:pt-10 justify-center lg:p-0 md:p-0 p-3  w-full lg:h-[90vh] mt-4">
          <div className="hidden lg:flex w-full  items-center justify-center">
            <img
              src={Loginimg}
              alt="Architectural background"
              className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
            />
        
              {/* <div className="absolute right-0 top-0 p-3">
                <img
                  src={Loginlogo}
                  alt="Architectural background"
                  className="max-w-xs"
                />
              </div> */}
            </div>

            <div className="w-full  flex  items-center">
              <div className="w-full lg:w-4/5 md:w-4/5">
                <h1 className="text-[36px] text-[#000000D9] text-start font-bold mb-[16px]">
                  Sign <span className="font-normal">in</span>
                </h1>
                <Form name="sign-in" layout="vertical" onFinish={handleLogin}>
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Please input your email!" },
                    ]}
                    style={{ marginBottom: "16px" }}
                  >
                    <Input
                      placeholder="Email"
                      className="text-[12px] h-10 w-full font-medium text-[#313131]"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                    style={{ marginBottom: "24px" }}
                  >
                    <Input.Password
                      placeholder="Password"
                      className="text-[12px] h-10 font-medium w-full text-[#313131]"
                    />
                  </Form.Item>
                  {error ? (
                    <span className="text-red-500 mb-3">{error}</span>
                  ) : (
                    ""
                  )}
                  <div className="text-right mb-[32px] w-full">
                    <div
                      onClick={() => {
                        setLoginView(false);
                      }}
                      className="text-[12px] cursor-pointer font-medium text-[#FF4545]"
                    >
                      Forgot Password?
                    </div>
                  </div>

                  <Form.Item>
                    <Button
                      loading={loader}
                      type="primary"
                      htmlType="submit"
                    
                      style={{
                        backgroundColor: "#2549FF",
                        height: "41px",
                        width: "100%",
                      }}
                      className="w-full font-medium text-[#FFFFFF] text-[14px] rounded active:bg-[#003C98]"
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#0445C3")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "#2549FF")
                      }
                    >
                      Log in
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </>
      ) : (
        <ForgotPass setLoginView={setLoginView} />
      )}
    </>
  );
};

export default Login;
